import { css } from '@emotion/react'

export const centerStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
`
